$('.featured-collection-slider').slick({
  speed: 300,
  variableWidth: true,
  prevArrow: '.featured-collection-prev',
  nextArrow: '.featured-collection-next',
  responsive: [
    {
      breakpoint: 480,
      settings: {
        variableWidth: false,
        slidesToScroll: 1,
        slidesToShow: 1,
        adaptiveHeight: true,
      }
    }
  ]
});

$('.customer-review__grid').slick({
  speed: 300,
  variableWidth: true,
  prevArrow: '.customer-review .slider-buttons .prev-button',
  nextArrow: '.customer-review .slider-buttons .next-button',
  responsive: [
    {
      breakpoint: 480,
      settings: {
        variableWidth: false,
        slidesToScroll: 1,
        slidesToShow: 1,
        adaptiveHeight: true,
      }
    }
  ]
});

$('.slideshow__carousel').slick({
  speed: 300,
  autoplay: true,
  autoplaySpeed: 5000,
  slidesToShow: 1,
  nextArrow: '.slideshow__carousel-button'
});

$('.variant-options-info span').on('click', function () {
  $('.variant-options-info span').removeClass('active');
  $(this).addClass('active');

  const scrollY = window.scrollY;

  $('.variant-input-wrap .variant-input[data-value="' + $(this).text() + '"] .variant__button-label').trigger('click');

  window.scrollTo({ top: scrollY });

  $('.product-variant-info-header strong').text($(this).text());
  $('.main-product .sticky-price .product__price.on-sale').text($('.main-product .product-block--price .product__price.on-sale').text());
  $('.main-product .sticky-price .product__price--compare').text($('.main-product .product-block--price .product__price--compare').text());
});

$('.show-hide-option').on('click', function () {
  $(this).toggleClass('active');
  $('.variant-options-info').toggleClass('active');
});

$(document).on('click', '.product-add-cart .add-to-cart', function (e) {
  e.preventDefault();      // stop the default link / form action
  e.stopPropagation();     // keep the click from bubbling up
  console.log('Add-to-cart button clicked');

  // Fire the “real” product add-to-cart button once
  $('.main-product .add-to-cart')
    .not(':disabled')      // skip disabled buttons just in case
    .first()               // grab the first match
    .trigger('click');
});

function isInViewport(el) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top < window.innerHeight &&
    rect.bottom > 0
  );
}

let wasVisible = null;

$(window).on('scroll resize', function () {
  const isVisible = isInViewport(document.querySelector('.main-product'));

  if (isVisible !== wasVisible) {
    if (isVisible) {
      $('.sticky-product').addClass('sticky-product-none');
    } else {
      $('.sticky-product').removeClass('sticky-product-none');
    }
    wasVisible = isVisible;
  }
});